

























import { Component, Prop, Vue } from 'vue-property-decorator'
import { PrepTask } from '@/models'
import { autoCheckName } from '@/utils/production-prep'

/** Badges next to a task name: optional, its help links and, with the definition, request and auto check */
@Component
export default class PrepTaskBadges extends Vue {
  @Prop({ required: true }) task: PrepTask
  @Prop({ default: false }) withDefinition: boolean

  autoCheckName(key: string): string {
    return autoCheckName(this, key)
  }
}
